import { useEffect, useState } from "react";
import { Check, Type } from "lucide-react";
import api from "@/lib/api";

const API = process.env.REACT_APP_BACKEND_URL;

/** الخطوط الإبداعية لاسم العلامة تحت الرمز — معاينة حقيقية لاسم العميل بكل خط (تُرسم في الخادم بالخط نفسه). */
export const WordmarkFontPicker = ({ value = "bold", onChange, brand = "", color = "" }) => {
  const [fonts, setFonts] = useState([]);
  useEffect(() => { api.get("/public/wordmark-fonts").then((r) => setFonts(r.data || [])).catch(() => setFonts([])); }, []);
  if (!fonts.length) return null;
  const text = encodeURIComponent((brand || "").trim() || "اسم علامتك");
  const col = (color || "#2B2B36").replace("#", "");
  return (
    <div className="rounded-xl border border-border bg-background/70 p-3 space-y-2" data-testid="wordmark-font-picker">
      <div className="text-xs font-bold flex items-center gap-1.5"><Type className="w-4 h-4 text-primary" /> خط اسم العلامة تحت الرمز — اختر الخط الإبداعي الذي يناسب هويتك</div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
        {fonts.map((f) => {
          const active = (value || "bold") === f.key;
          return (
            <button type="button" key={f.key} onClick={() => onChange(f.key)} title={f.desc}
              className={`relative rounded-lg border p-2 text-center transition-colors ${active ? "border-primary bg-primary/10 ring-2 ring-primary/30" : "border-border bg-background hover:border-primary/40"}`}
              data-testid={`wordmark-font-${f.key}`}>
              <img src={`${API}/api/public/wordmark-preview/${f.key}.png?text=${text}&color=${col}`} alt={f.name} className="h-10 w-full object-contain" loading="lazy" draggable={false} />
              <div className="text-[11px] font-bold mt-1 flex items-center justify-center gap-1">{active && <Check className="w-3 h-3 text-primary" />}{f.name}</div>
              <div className="text-[10px] text-muted-foreground leading-tight">{f.desc}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
};
